"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogContent = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const DialogContent_1 = tslib_1.__importDefault(require("@mui/material/DialogContent"));
/**
 *
 * A wrapper around {@link @mui/material.DialogContent}. It changes the default behavior to always
 * display a divider at the bottom and top of the content. This is done by defining a default value for the `divider` prop.
 *
 * @see See {@link Dialog} for examples
 */
const DialogContent = (props, ref) => {
    const { divider = "both", ...rest } = props;
    return (react_1.default.createElement(DialogContent_1.default, { ref: ref, dividers: divider === "both", sx: theme => Object.assign({}, divider === "bottom" && ({
            borderBottom: `1px solid ${theme.palette.divider}`,
            pb: 2,
        }), divider === "top" && ({
            borderTop: `1px solid ${theme.palette.divider}`,
            pt: 2,
        })), ...rest }));
};
exports.DialogContent = DialogContent;
const DialogContentWithRef = react_1.default.forwardRef(exports.DialogContent);
if (process.env.NODE_ENV !== "production") {
    // @ts-ignore: Exposed for test purposes
    DialogContentWithRef.Naked = exports.DialogContent;
}
exports.default = DialogContentWithRef;
